import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { finalize, first } from 'rxjs';
import { LoadingDefaults } from '../../../shared/models/loading-defaults.model';
import {
  DriverResponse,
  DriversClient,
} from '../../../shared/services/api-client';
import { RplLoadingService } from '../../../shared/services/rpl-loading.service';

export const driverResolverFactory = (
  driverId: number,
): ResolveFn<DriverResponse> => {
  return () => {
    const client = inject(DriversClient);
    const loadingService = inject(RplLoadingService);
    let loadingId: string | undefined;

    const timeout = setTimeout(() => {
      loadingId = loadingService.start();
    }, LoadingDefaults.StartIndicatorTimeout);

    return client.getDriver(driverId).pipe(
      first(),
      finalize(() => {
        clearTimeout(timeout);
        loadingService.end(loadingId);
      }),
    );
  };
};
